// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.5 4C3.5 2.62 4.62 1.5 6 1.5C7.38 1.5 8.5 2.62 8.5 4L8.5 5C8.5 6.38 7.38 7.5 6 7.5C4.62 7.5 3.5 6.38 3.5 5L3.5 4',
  'M7.2 9.74C6.82 9.65 6.42 9.59 6.02 9.59C4.6 9.62 3.18 10.21 2.14 11.34L1.87 11.67C1.33 12.42 1.39 13.36 2.01 14.05C2.26 14.34 2.63 14.5 3.02 14.5L7.2 14.5',
  'M13.65 11.25C13.65 12.38 12.73 13.3 11.6 13.3C10.47 13.3 9.55 12.38 9.55 11.25C9.55 10.12 10.47 9.2 11.6 9.2C12.73 9.2 13.65 10.12 13.65 11.25Z',
  'M13.05 12.7L14.5 14.15',
];
